"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FreeService = void 0;
const Service_1 = require("./Service");
/**
 * Представляет свободный сервис. Свободный сервис никак не контролирует
 * количество своих экземпляров, поручая внешним классам управлять их
 * созданием и уничтожением. Рекомендуется использовать свободные сервисы
 * как составные части ленивых сервисов, вызывая их методы dispose при
 * удалении экземпляра-аргегата.
 */
class FreeService extends Service_1.Service {
}
exports.FreeService = FreeService;
